'use client';
import { AuthContext } from '@web-libs/features/auth/main/application/use-auth.concern';
import { ReactNode} from 'react';
import {
  provideAuthRepository,
  useProvideAuthAngular
} from '@web-libs/features/auth/main/infrastructure/provide-auth.concern';
import { useHttpContext } from '@web-libs/core/http/infrastructure/client-side/http.context';
import { LoginRequestBranding } from '@web-libs/features/auth/main/domain/auth.types';
import { Theme } from '@web-libs/features/branding/theme/domain/theme.types';
import { LoadingIndicator } from '@web-libs/ui/ui-components/loading/loading-indicator';

export const AuthProvider = ({ children, theme, logoUrl }: { children: ReactNode, theme: Theme, logoUrl?: string }) => {
  const httpConcern = useHttpContext();
  const authRepository = provideAuthRepository(httpConcern);
  const defaultLogoUrl = typeof window !== 'undefined' ? window.location.host + '/tagea-logo.svg' : '';
  const loginRequestBranding: LoginRequestBranding = {
    logoUrl: logoUrl ? logoUrl : defaultLogoUrl,
    primaryColor: theme.primary!
  };

  const [concern,concernReady] = useProvideAuthAngular(httpConcern, authRepository, loginRequestBranding);

  if(!concernReady) {
    return <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      width: '100vw'
    }}><LoadingIndicator></LoadingIndicator></div>
  }

  return <AuthContext.Provider value={concern}>
    {children}
  </AuthContext.Provider>;
};
